import { render, staticRenderFns } from "./RELCumprimentoRota.vue?vue&type=template&id=82b07bd4&"
import script from "./RELCumprimentoRota.vue?vue&type=script&lang=js&"
export * from "./RELCumprimentoRota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports